export const LIST = {
  SHAPE: { ROUND: "round", DEFAULT: "default" },
  SIZE: { LARGE: "large", COMPACT: "compact", DEFAULT: "default" },
} as const;
